var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7279 9.5758L14.3137 8.16158L5 17.4753V18.8895H6.41421L15.7279 9.5758ZM17.1421 8.16158L18.5563 6.74737L17.1421 5.33316L15.7279 6.74737L17.1421 8.16158ZM7.24264 20.8895H3V16.6469L16.435 3.21184C16.8256 2.82131 17.4587 2.82131 17.8492 3.21184L20.6777 6.04026C21.0682 6.43079 21.0682 7.06395 20.6777 7.45448L7.24264 20.8895Z",
    fill: "#2948CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilLine);
export default __webpack_public_path__ + "static/media/pencil-line.e4b64800affd45a5fd47df6de559c801.svg";
export { ForwardRef as ReactComponent };